const ANIMATION_OFFSET_Y = 30;
const STAGGER_CHILDREN = 0.12;

export const fadeUp = {
  hidden: { opacity: 0, y: ANIMATION_OFFSET_Y },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
  },
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: STAGGER_CHILDREN } },
};

// Shared viewport configs for scroll-triggered reveals (stable references)
export const VIEWPORT_LG = { once: true, margin: "-80px" };
export const VIEWPORT_SM = { once: true, margin: "-60px" };
